var module = angular.module('octopusApp.projects');

module.controller('ProjectReleaseEditController', function ($scope, busy, $timeout, $location, $stateParams, pageTitle, octopusLog, octopusRepository, $uibModal, unsavedChanges) {
    var isLoading = $scope.isLoading = busy.create();
    var isSaving = $scope.isSaving = busy.create();
    var projectId = $stateParams.projectId;
    var channelId = $stateParams.channelId;
    var releaseVersion = $stateParams.version;

    $scope.deploymentProcess = null;
    $scope.packageSelections = [];
    $scope.hasBeenModified = false;
    $scope.violatedPackages = [];
    $scope.versionModified = function () {
        $scope.hasBeenModified = true;
    };
    $scope.setVersionSatisfaction = setVersionSatisfaction;
    $scope.options = {
        ignoreChannelRules: false
    };

    $scope.channels = [];

    $scope.showSearchDialog = function (pkg) {
        $uibModal.open({
            backdrop: true,
            keyboard: true,
            templateUrl: 'areas/projects/views/package_list_dialog.html',
            controller: 'ProjectReleasePackageListController',
            resolve: {
                currentPackage: function () {
                    return pkg;
                },
                channelFilters: function () {
                    return getChannelFilters(pkg.StepName);
                }
            }
        }).result.then(function (result) {
            if (result) {
                pkg.SpecificVersion = result;
                pkg.VersionType = 'specific';
                $scope.packageVersionChanged(pkg, result);
            }
        });
    };

    $scope.specificVersionSelected = function(pkg){
        pkg.VersionType = "specific";
        setVersionSatisfaction(pkg, pkg.SpecificVersion);
    };

    $scope.packageVersionChanged = function (pkg, version) {
        if ($scope.template.VersioningPackageStepName && $scope.template.VersioningPackageStepName === pkg.StepName) {
            $scope.release.Version = version;
        }
        setVersionSatisfaction(pkg, version);
    };

    $scope.save = function () {
        var release = $scope.release;
        release.SelectedPackages = [];
        for (var i = 0; i < $scope.packageSelections.length; i++) {
            var selection = $scope.packageSelections[i];
            var selectedVersion = '';
            if (selection.VersionType === 'latest') {
                selectedVersion = selection.LatestVersion;
            } else if (selection.VersionType === 'last') {
                selectedVersion = selection.LastReleaseVersion;
            } else if (selection.VersionType === 'specific') {
                selectedVersion = selection.SpecificVersion;
            }

            release.SelectedPackages.push({
                'StepName': selection.StepName,
                'Version': selectedVersion
            });
        }

        if ($scope.channels.Items === 1) {
            release.ChannelId = $scope.channels.Items[0].Id;
        }

        isSaving.promise(octopusRepository.Releases.save(release, {ignoreChannelRules: $scope.options.ignoreChannelRules}).then(function (newRelease) {
            unsavedChanges.saved();
            $location.path("/projects/" + $scope.project.Slug + "/releases/" + newRelease.Version);
        }));
    };

    $scope.channelSelected = function () {
        loadTemplate();
    };

    function init() {
        isLoading.promise(octopusRepository.Projects.get(projectId).then(function (project) {
            $scope.project = project;
            isLoading.promise(octopusRepository.Projects.getChannels(project))
              .then(function (channels) {
                  $scope.channels = channels;

                  if (angular.isDefined(releaseVersion) && releaseVersion !== null) {
                      isLoading.promise(octopusRepository.Projects.getReleaseByVersion(project, releaseVersion).then(function (release) {
                          $scope.release = release;
                          $scope.originalVersion = release.Version;
                          $scope.originalChannelId = $scope.release.ChannelId;
                          pageTitle("Edit release " + release.Version);
                          loadDeploymentProcess(release.ProjectDeploymentProcessSnapshotId);
                      }));
                  } else {
                      var defaultChannel = _.find($scope.channels.Items, function (channel) {
                          return channel.IsDefault;
                      });
                      $scope.release = {
                          ProjectId: project.Id,
                          ChannelId: channelId ? channelId : defaultChannel ? defaultChannel.Id : $scope.channels.Items[0].Id
                      };
                      pageTitle("Create release for " + project.Name);
                      loadDeploymentProcess(project.DeploymentProcessId);
                  }
              });
        }));
    }

    function getChannelFilters(deploymentActionName) {
        var filters = {};

        if (!$scope.release.ChannelId) {
            return filters;
        }

        var applicableRules = $scope.channels.Items
            .filter(function (x) {
                return x.Id === $scope.release.ChannelId;
            })[0]
            .Rules
            .filter(function (rule) {
                return rule.Actions.length === 0 || _.contains(rule.Actions, deploymentActionName);
            })[0];

        if (applicableRules && applicableRules.VersionRange) {
            filters.versionRange = applicableRules.VersionRange;
        }

        if (applicableRules && applicableRules.Tag) {
            filters.preReleaseTag = applicableRules.Tag;
        }

        return filters;
    }

    function setVersionSatisfaction(pkg, version) {
        var filters = getChannelFilters(pkg.StepName);

        octopusRepository.Channels.ruleTest(version, {
            versionRange: filters.versionRange,
            preReleaseTag: filters.preReleaseTag
        }).then(function (result) {
            pkg.isSelectedVersionValid = result.Errors.indexOf("Invalid Version Number") !== -1 || (result.SatisfiesVersionRange && result.SatisfiesPreReleaseTag);

            var position = $scope.violatedPackages.indexOf(pkg.StepName);
            if (pkg.isSelectedVersionValid && position !== -1) {
                $scope.violatedPackages.splice(position, 1);
            } else if (!pkg.isSelectedVersionValid && position === -1) {
                $scope.violatedPackages.push(pkg.StepName);
            }
        });
    }

    function loadVersions(selectionsByFeed) {
        octopusLog.log("Loading packages by feed", selectionsByFeed);
        $scope.feedLoadingError = null;

        _.each(selectionsByFeed, function (selections, feedId) {

            isLoading.promise(octopusRepository.Feeds.get(feedId).then(function (feed) {
                _.each(selections, function (selection) {

                    var filters = getChannelFilters(selection.StepName);
                    checkForRuleSatisfaction(selection, filters);

                    var searchOptions = _.extend({
                        packageId: selection.PackageId,
                        partialMatch: false,
                        includeMultipleVersions: false,
                        includePreRelease: true,
                        includeNotes: false,
                        take: 1
                    }, filters);

                    octopusRepository.Feeds.search(feed, searchOptions).then(function (packages) {
                        if (packages.length > 0) {
                            var pkg = packages[0];
                            selection.LatestVersion = pkg.Version;

                            if (!$scope.release.Id) {
                                $scope.packageVersionChanged(selection, pkg.Version);
                            } else {
                                setVersionSatisfaction(selection, selection.SpecificVersion);
                            }
                        }
                        else { // no latest version found
                            selection.IsResolvable = false;
                            selection.VersionType = "specific";
                            selection.ErrorLoadingLatest = "Could not find the latest version of package " + selection.PackageId + " in this feed.";
                            setVersionSatisfaction(selection, selection.SpecificVersion);
                        }
                    },
            function (err) {
                if (!$scope.feedLoadingError) {
                    $scope.feedLoadingError = err;
                }
            }
          );
                });
            }));
        });

        function checkForRuleSatisfaction(selection, filters) {
            if (selection.LastReleaseVersion) {
                octopusRepository.Channels.ruleTest(selection.LastReleaseVersion, {
                    versionRange: filters.versionRange,
                    preReleaseTag: filters.preReleaseTag
                }).then(function (result) {
                    selection.isLastReleaseVersionValid = result.SatisfiesVersionRange && result.SatisfiesPreReleaseTag;
                });
            } else {
                selection.isLastReleaseVersionValid = false;
            }
        }
    }

    function loadDeploymentProcess(processId) {
        isLoading.promise(octopusRepository.DeploymentProcesses.get(processId).then(function (deploymentProcess) {
            $scope.deploymentProcess = deploymentProcess;
            loadTemplate();
        }));
    }

    function loadTemplate() {
        var deploymentProcess = $scope.deploymentProcess;
        isLoading.promise(octopusRepository.DeploymentProcesses.getTemplate(deploymentProcess, $scope.release.ChannelId).then(function (template) {
            $scope.template = template;
            $scope.deploymentProcess = deploymentProcess;
            if (!$scope.release.Id) {
                if (template.NextVersionIncrement) {
                    $scope.release.Version = template.NextVersionIncrement;
                }
            }

            var existingSelections = {};
            if ($scope.release.SelectedPackages) {
                for (var k = 0; k < $scope.release.SelectedPackages.length; k++) {
                    existingSelections[$scope.release.SelectedPackages[k].StepName] = $scope.release.SelectedPackages[k].Version;
                }
            }

            var selectionByFeed = {};
            $scope.packageSelections = [];
            for (var i = 0; i < template.Packages.length; i++) {
                var selection = {};
                selection.StepName = template.Packages[i].StepName;
                selection.PackageId = template.Packages[i].PackageId;
                selection.FeedId = template.Packages[i].FeedId;
                selection.FeedName = template.Packages[i].FeedName;
                selection.LatestVersion = '';
                selection.SpecificVersion = angular.isDefined(existingSelections[selection.StepName]) ? existingSelections[selection.StepName] : '';
                selection.IsResolvable = template.Packages[i].IsResolvable;
                selection.LastReleaseVersion = template.Packages[i].VersionSelectedLastRelease;
                selection.VersionType = selection.SpecificVersion ? 'specific' : (selection.IsResolvable ? 'latest' : (selection.LastReleaseVersion ? 'last' : 'specific'));
                selection.isLastReleaseVersionValid = false;

                $scope.packageSelections.push(selection);

                if (selection.IsResolvable) {
                    if (!selectionByFeed[selection.FeedId]) {
                        selectionByFeed[selection.FeedId] = [];
                    }

                    selectionByFeed[selection.FeedId].push(selection);
                }
            }

            loadVersions(selectionByFeed);
        }));
    }

    init();
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/controllers/project_release_edit_controller.js
// module id = 524
// module chunks = 1